import React from "react";
import intl from "react-intl-universal";
import {useUserState} from "@stores/AppStateContext";

import {ContextMenuInterface} from "../../ContextMenuInterface";

import {PreviewIcon} from "../../../../components/icons/editor/PreviewIcon";
import {ImageSmallIcon} from "../../../../components/icons/editor/ImageSmallIcon";
import {ImageNormalIcon} from "../../../../components/icons/editor/ImageNormalIcon";
import {ImageLargeIcon} from "../../../../components/icons/editor/ImageLargeIcon";
import {DownloadIcon} from "../../../../components/icons/DownloadIcon";
import {DeleteIcon} from "../../../../components/icons/DeleteIcon";

import {openPreview} from "../../../../../Editor/module/commands/image/openPreview";
import {setViewSizeSmall, setViewSizeNormal, setViewSizeLarge} from "../../../../../Editor/module/commands/common/size";
import {downloadImage} from "../../../../../Editor/module/commands/image/downloadImage";
import {deleteImage} from "../../../../../Editor/module/commands/image/deleteImage";
import {isAttributeValueActive} from "../../../../../Editor/utils/isAttributeValueActive";

import {schema} from '../../../../../Editor/module/config/schema';

import {GroupedActions, ContextAction} from "../utils/GroupedActions";
import {UserSessionState} from "@stores/UserSessionState";

export interface ImageContextPropsSelfProps {
    getPos: () => number | undefined,
}

export interface ImageToolbarProps extends ContextMenuInterface, ImageContextPropsSelfProps {
}

const previewActions: ContextAction[] = [
    {
        id: 'preview',
        Icon: PreviewIcon,
        getTitle: () => intl.get('image-toolbar.preview').d('Preview'),
        action: openPreview,
    },
]

const sizeActions: ContextAction[] = [
    {
        id: 'small',
        Icon: ImageSmallIcon,
        getTitle: () => intl.get('image-toolbar.small').d('Small'),
        action: setViewSizeSmall,
        active: isAttributeValueActive(schema.nodes.image, 'display', 'small'),
    },
    {
        id: 'normal',
        Icon: ImageNormalIcon,
        getTitle: () => intl.get('image-toolbar.normal').d('Normal'),
        action: setViewSizeNormal,
        active: isAttributeValueActive(schema.nodes.image, 'display', 'normal'),
    },
    {
        id: 'large',
        Icon: ImageLargeIcon,
        getTitle: () => intl.get('image-toolbar.large').d('Large'),
        action: setViewSizeLarge,
        active: isAttributeValueActive(schema.nodes.image, 'display', 'large'),
    },
]

const otherActions: ContextAction[] = [
    {
        id: 'download',
        Icon: DownloadIcon,
        getTitle: () => intl.get('image-toolbar.download').d('Download'),
        action: downloadImage,
    },
];

const deleteActions: ContextAction[] = [
    {
        id: 'delete',
        Icon: DeleteIcon,
        getTitle: () => intl.get('common.delete').d('Delete'),
        action: deleteImage,
    },
]

const groupedAdminActions: ContextAction[][] = [
    previewActions,
    sizeActions,
    otherActions,
    deleteActions,
];

const groupedReaderActions: ContextAction[][] = [
    previewActions,
    otherActions,
];

export const ImageToolbar = ({handleClose, isDark, ...specificParams}: ImageToolbarProps) => {
    const userState = useUserState()!;
    const _isReadOnly = userState!.isCurrentUserReadOnly;
    return <GroupedActions
        handleClose={handleClose}
        actionGroups={_isReadOnly ? groupedReaderActions : groupedAdminActions}
        additionalParams={specificParams}
        isDark={isDark}
    />
}

